import { settingMenu } from "@/features/system-setting/constants/settingMenu";
import { Tab } from "@/modules/irohana-components/elements/Tab";
import { TopPage } from "@/modules/irohana-components/elements/TopPage";
import { black } from "@/theme/colors";
import { getDynamicRoute } from "@/utils/url";
import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { matchRoutes, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

type TSettingLayoutProps = {};

export const SettingLayout: FC<TSettingLayoutProps> = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const activeIndex = settingMenu.findIndex(({ url }) => matchRoutes([{ path: url }], pathname) !== null);
  const activeUrl = settingMenu[activeIndex !== -1 ? activeIndex : 0].url;

  const handleChange = (_event: React.SyntheticEvent, value: string | number) => {
    navigate(getDynamicRoute(String(value), { id }));
  };

  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 1.5 }}>
        <TopPage title="システム設定" enablePageBack={false} />
      </Box>

      <Box
        sx={{
          mt: 1.5,
          "& .MuiTabs-flexContainer .MuiButtonBase-root.MuiTab-root": {
            padding: "12px 16px",
            minHeight: "48px",
            lineHeight: "150%",
            borderRadius: "5px 5px 0 0",
          },
        }}
      >
        <Tab
          value={activeUrl}
          selected={activeUrl}
          onChange={handleChange}
          options={settingMenu.map(({ title, url }) => ({ label: title, value: url }))}
          bgColor="transparent"
          tabGap="8px"
          tabFontSize="20px"
          tabHeight="auto"
          borderBottomColor={black[30]}
          activeTabColor={black[30]}
          inactiveTabColor={black[95]}
        />
      </Box>

      <Outlet />
    </Stack>
  );
};
